__webpack_require__.p = "/move-shared-components/referrals/";